import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
  Tooltip,
  useTheme,
  IconButton,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IRequestOwnerInfo } from "src/Types/module/UpdateRequest/RequestCompanyInfo";
import { getStatusLabel } from "src/Utils/Combined";

interface IProps {
  isLoading: boolean;
  ownerInfo: IRequestOwnerInfo[];
}
const OwnerInfoIndex = ({ isLoading, ownerInfo }: IProps) => {
  const theme = useTheme();
  return (
    <div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Company Name</TableCell>
              <TableCell>Owner Name</TableCell>
              <TableCell>Designation</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableLoader />
            ) : ownerInfo.length ? (
              <>
                {ownerInfo.map((sOwner) => {
                  return (
                    <TableRow hover key={sOwner.request_id}>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sOwner.company_owner_id}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sOwner.member_company_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sOwner.company_owner_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sOwner.company_owner_designation}
                        </Typography>
                      </TableCell>
                      <TableCell>{getStatusLabel(sOwner.status)}</TableCell>

                      <TableCell>
                        <Link
                          to={`/update-request/owner-info/${sOwner.request_id}?memberid=${sOwner.user_member_id}`}
                        >
                          <Tooltip title="view" arrow>
                            <IconButton
                              sx={{
                                "&:hover": {
                                  background: theme.colors.primary.lighter,
                                },
                                color: theme.palette.primary.main,
                              }}
                              color="inherit"
                              size="small"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <TableNotFound />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default OwnerInfoIndex;
